var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.466 12.0002L19.6962 5.76984C20.1017 5.36458 20.1017 4.70933 19.6962 4.30407C19.291 3.89881 18.6357 3.89881 18.2305 4.30407L12.0001 10.5345L5.76986 4.30407C5.36441 3.89881 4.70935 3.89881 4.30409 4.30407C3.89864 4.70933 3.89864 5.36458 4.30409 5.76984L10.5343 12.0002L4.30409 18.2306C3.89864 18.6359 3.89864 19.2912 4.30409 19.6964C4.50605 19.8986 4.77161 20.0001 5.03698 20.0001C5.30234 20.0001 5.56771 19.8986 5.76986 19.6964L12.0001 13.466L18.2305 19.6964C18.4326 19.8986 18.698 20.0001 18.9634 20.0001C19.2287 20.0001 19.4941 19.8986 19.6962 19.6964C20.1017 19.2912 20.1017 18.6359 19.6962 18.2306L13.466 12.0002Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.22b6dcbe9e933eee5ed136c36ee68a11.svg";
export { ForwardRef as ReactComponent };